export const DEFAULT_PAGINATION = { page: 1, limit: 10, total: 0 };
